import { Injectable } from "@angular/core";
import { Guid } from "guid-typescript";
import * as moment from "moment";
import { Model_LogVariableEnvironnementUser } from 'src/app/app.models';
import { PlatformResult, API_RESULT_STATUS } from '../../platform/platform.service';
import { LogEnvVarUserOfflineDao } from './log-envvaruser-offline.dao';
import { QueryParams_LogVariableEnvironnementUser } from 'src/app/pages/views/settings/variable-environment/variable-environment.service';

export interface LogVariableEnvironnementUserApi {
    doSyncLogsVariableEnvironnementUserAction(responsesWorkflowRaw: string);
    onLogsVariableEnvironnementUserSynced(_result: PlatformResult);

    doClearLogsVariableEnvironnementUserAction();
    onLogsVariableEnvironnementUserCleared(_result: PlatformResult);

    doGetLogsVariableEnvironnementUserAction(_queryParams: string);
    onLogsVariableEnvironnementUserFetched(_result: PlatformResult);

    doInsertLogsVariableEnvironnementUserAction(logVariableEnvironnementUsersRaw: string);
    onLogsVariableEnvironnementUserInserted(_result: PlatformResult);

    doCreateLogVariableEnvironnementUserAction(logVariableEnvironnementUsersRaw: string);
    onLogVariableEnvironnementUserCreated(result: PlatformResult);

    doUpdateLogVariableEnvironnementUserAction(logVariableEnvironnementUsersRaw: string);
    onLogVariableEnvironnementUserUpdated(result: PlatformResult);

    doGetLogVariableEnvironnementUserAction(guid: string);
    onLogVariableEnvironnementUserFetched(result: PlatformResult);

    doDeleteLogVariableEnvironnementUserAction(guid: string);
    onLogVariableEnvironnementUserDeleted(result: PlatformResult);
}

@Injectable()
export class LogEnvVarUserOfflineAndroidDao extends LogEnvVarUserOfflineDao {
    doSyncLogsEnvVarUserAction(logs: Model_LogVariableEnvironnementUser[]): Promise<void> {
        return new Promise((resolve, reject) => {
            window['LogVariableEnvironnementUserApi'].onLogsVariableEnvironnementUserSynced = (_result: PlatformResult) => {
                delete window['LogVariableEnvironnementUserApi'].onLogsVariableEnvironnementUserSynced;
                if (_result.status == API_RESULT_STATUS.SUCCESS) {
                    resolve();
                } else {
                    reject(_result.error);
                }
            };
            const logVariableEnvironnementUserApi: LogVariableEnvironnementUserApi = window['LogVariableEnvironnementUserApi'];
            logVariableEnvironnementUserApi.doSyncLogsVariableEnvironnementUserAction(JSON.stringify(logs))
        });
    }

    doClearLogsEnvVarUserAction() {
        return new Promise<void>((resolve, reject) => {
            window['LogVariableEnvironnementUserApi'].onLogsVariableEnvironnementUserCleared = (_result: PlatformResult) => {
                delete window['LogVariableEnvironnementUserApi'].onLogsVariableEnvironnementUserCleared;
                if (_result.status == API_RESULT_STATUS.SUCCESS) {
                    resolve();
                } else {
                    reject(_result.error);
                }
            };
            const logVariableEnvironnementUserApi: LogVariableEnvironnementUserApi = window['LogVariableEnvironnementUserApi'];
            logVariableEnvironnementUserApi.doClearLogsVariableEnvironnementUserAction()
        });
    }

    doGetLogsEnvVarUserAction(_queryParams?: QueryParams_LogVariableEnvironnementUser): Promise<Model_LogVariableEnvironnementUser[]> {
        if (_queryParams === undefined) 
            _queryParams = new QueryParams_LogVariableEnvironnementUser();

        return new Promise<Model_LogVariableEnvironnementUser[]>((resolve, reject) => {
            window['LogVariableEnvironnementUserApi'].onLogsVariableEnvironnementUserFetched = (_result: PlatformResult) => {
                delete window['LogVariableEnvironnementUserApi'].onLogsVariableEnvironnementUserFetched;
                if (_result.status == API_RESULT_STATUS.SUCCESS) {
                    resolve(_result.datas);
                } else {
                    reject(_result.error);
                }
            };
            const logVariableEnvironnementUserApi: LogVariableEnvironnementUserApi = window['LogVariableEnvironnementUserApi'];
            logVariableEnvironnementUserApi.doGetLogsVariableEnvironnementUserAction(JSON.stringify(_queryParams));
        });
    }

    doInsertLogsEnvVarUserAction(logs: Model_LogVariableEnvironnementUser[]): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            window['LogVariableEnvironnementUserApi'].onLogsVariableEnvironnementUserInserted = (_result: PlatformResult) => {
                delete window['LogVariableEnvironnementUserApi'].onLogsVariableEnvironnementUserInserted;
                if (_result.status == API_RESULT_STATUS.SUCCESS) {
                    resolve();
                } else {
                    reject(_result.error);
                }
            };
            const logVariableEnvironnementUserApi: LogVariableEnvironnementUserApi = window['LogVariableEnvironnementUserApi'];
            logVariableEnvironnementUserApi.doInsertLogsVariableEnvironnementUserAction(JSON.stringify(logs));
        });
    }

    doSaveLogEnvVarUserAction(log: Model_LogVariableEnvironnementUser): Promise<Model_LogVariableEnvironnementUser> {
        return new Promise<Model_LogVariableEnvironnementUser>((resolve, reject) => {

            const logVariableEnvironnementUserAPi: LogVariableEnvironnementUserApi = window['LogVariableEnvironnementUserApi'];
            if (log.ID === undefined && log.GUID_SYNCHRONISATION === undefined) {
                window['LogVariableEnvironnementUserApi'].onLogVariableEnvironnementUserCreated = (_result: PlatformResult) => {
                    delete window['LogVariableEnvironnementUserApi'].onLogVariableEnvironnementUserCreated;
                    if (_result.status == API_RESULT_STATUS.SUCCESS) {
                        resolve(log);
                    } else {
                        reject(_result.error);
                    }
                };
                log.GUID_SYNCHRONISATION = Guid.create().toString();
                logVariableEnvironnementUserAPi.doCreateLogVariableEnvironnementUserAction(JSON.stringify(log));
            } else if (log.GUID_SYNCHRONISATION !== undefined) {
                window['LogVariableEnvironnementUserApi'].onLogVariableEnvironnementUserUpdated = (_result: PlatformResult) => {
                    delete window['LogVariableEnvironnementUserApi'].onLogVariableEnvironnementUserUpdated;
                    if (_result.status == API_RESULT_STATUS.SUCCESS) {
                        resolve(log);
                    } else {
                        reject(_result.error);
                    }
                };
                logVariableEnvironnementUserAPi.doUpdateLogVariableEnvironnementUserAction(JSON.stringify(log));
            }
        });
    }

    doGetLogEnvVarAction(_guid: string): Promise<Model_LogVariableEnvironnementUser> {
        return new Promise((resolve, reject) => {
            window['LogVariableEnvironnementUserApi'].onLogVariableEnvironnementUserFetched = (_result: PlatformResult) => {
                delete window['LogVariableEnvironnementUserApi'].onLogVariableEnvironnementUserFetched;
                if (_result.status == API_RESULT_STATUS.SUCCESS) {
                    resolve(_result.datas);
                } else {
                    reject(_result.error);
                }
            };
            const logVariableEnvironnementUserAPi: LogVariableEnvironnementUserApi = window['LogVariableEnvironnementUserApi'];
            logVariableEnvironnementUserAPi.doGetLogVariableEnvironnementUserAction(_guid);
        });
    }

    doDeleteLogEnvVarUserAction(_guid: string): Promise<void> {
        return new Promise((resolve, reject) => {
            window['LogVariableEnvironnementUserApi'].onLogVariableEnvironnementUserDeleted = (_result: PlatformResult) => {
                delete window['LogVariableEnvironnementUserApi'].onLogVariableEnvironnementUserDeleted;
                if (_result.status == API_RESULT_STATUS.SUCCESS) {
                    resolve();
                } else {
                    reject(_result.error);
                }
            };
            const logVariableEnvironnementUserAPi: LogVariableEnvironnementUserApi = window['LogVariableEnvironnementUserApi'];
            logVariableEnvironnementUserAPi.doDeleteLogVariableEnvironnementUserAction(_guid);
        });
    }
}
